angular.module('zc.zenclerkS')

  .component('zcsEstimatedRevenue', {
    templateUrl: '/templates/zenclerk_s/directives/estimated_revenue/estimated_revenue.html',
    bindings: {
      revenue: '=',
      project: '=',
    },
    controllerAs: 'vm',
    controller: function(currencies) {
      const vm = this;
      vm.limit = 1000;
      vm.currency = currencies[vm.project.currency];
    }
  });



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/estimated_revenue/estimated_revenue.js